import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import authReducer from './authslice';
import entityAccountReducer from './EntityAccountReducer';
import loginReducer from './LoginReducer';
import resetPasswordReducer from './ResetPasswordReducer';
import { reducer as formReducer } from 'redux-form';
import { themeReducer } from './authslice'; 

// Persist config for auth slice — survives page refresh within the same tab
const authPersistConfig = {
  key: 'auth',
  storage: storageSession,
  blacklist: [
    'password',
    // Removed base64 image fields from blacklist; they now store lightweight URLs securely
  ],
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    entityAccount: entityAccountReducer,
    loginAccount: loginReducer,
    resetPassword: resetPasswordReducer,
    form: formReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // redux-persist dispatches non-serializable actions — ignore them
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
